"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportWithWrapText = void 0;
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var exceljs_1 = __importDefault(require("exceljs"));
// 辅助函数：计算列宽-根据文字
function calculateTextWidth(content) {
    if (!content)
        return 10; // 默认宽度
    // 计算中英文混合宽度
    var width = 0;
    for (var _i = 0, content_1 = content; _i < content_1.length; _i++) {
        var char = content_1[_i];
        width += char.charCodeAt(0) > 255 ? 2 : 1;
    }
    return Math.min(Math.max(width, 10), 50); // 限制最小10，最大50
}
/**
 * 计算列的自适应宽度
 * @param {Array} data 数据数组
 * @param {string} key 要计算的字段名
 * @param {string} header 表头文本
 * @param {number} [padding=3] 额外填充宽度
 * @returns {number} 计算后的列宽
 */
function calculateColumnWidth(data, key, header, padding) {
    if (padding === void 0) { padding = 6; }
    // 计算表头宽度
    var maxWidth = calculateTextWidth(header);
    // 计算数据内容最大宽度
    data.forEach(function (item) {
        var content = item[key] || '';
        var lines = String(content).split('\r\n'); // 处理换行内容
        lines.forEach(function (line) {
            var lineWidth = calculateTextWidth(line);
            if (lineWidth > maxWidth) {
                maxWidth = lineWidth;
            }
        });
    });
    // 添加padding并限制最小/最大宽度
    return Math.min(Math.max(maxWidth + padding, 8), 60); // 最小8，最大60
}
// 创建下载链接
function saveAs(blob, filename) {
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    setTimeout(function () { return URL.revokeObjectURL(link.href); }, 100);
}
function exportWithWrapText(jsonData, fileName) {
    if (fileName === void 0) { fileName = 'export'; }
    return __awaiter(this, void 0, void 0, function () {
        var workbook, worksheet, headers, headerRow, buffer, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(jsonData === null || jsonData === void 0 ? void 0 : jsonData.length)) {
                        return [2 /*return*/, false];
                    }
                    workbook = new exceljs_1.default.Workbook();
                    worksheet = workbook.addWorksheet('Sheet1');
                    headers = Object.keys(jsonData[0] || {});
                    worksheet.addRow(headers);
                    headerRow = worksheet.getRow(1);
                    headerRow.height = 20; // 约40像素
                    headerRow.eachCell(function (cell) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD3D3D3' },
                        };
                        cell.font = { bold: true };
                    });
                    // 3. 添加数据行并处理换行
                    jsonData.forEach(function (item) {
                        var row = worksheet.addRow(Object.values(item));
                        // 遍历每个单元格
                        row.eachCell(function (cell, colNumber) {
                            var value = cell.value;
                            cell.font = {
                                size: 12,
                            };
                            // 检测是否包含换行符
                            if (typeof value === 'string' && (value.includes('\n') || value.includes('\r'))) {
                                // 设置自动换行
                                cell.alignment = {
                                    wrapText: true,
                                    vertical: 'top', // 顶部对齐（多行文本更美观）
                                };
                            }
                        });
                    });
                    // 4. 智能列宽计算（考虑换行内容）
                    worksheet.columns = headers.map(function (header, idx) {
                        return {
                            header: header,
                            key: header,
                            width: calculateColumnWidth(jsonData, header, header),
                            style: { alignment: { vertical: 'top' } },
                        };
                    });
                    return [4 /*yield*/, workbook.xlsx.writeBuffer()];
                case 1:
                    buffer = _a.sent();
                    blob = new Blob([buffer], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    fileName = "".concat(fileName, ".xlsx");
                    saveAs(blob, fileName);
                    return [2 /*return*/];
            }
        });
    });
}
exports.exportWithWrapText = exportWithWrapText;
//# sourceMappingURL=XlsxExport.js.map